import {TABLE_CONFIG_DEFAULT} from '@app/ng-zorro/nz-config/nz-common.config';
import {AppTableConfig} from '@shared/components/app-table/app-table.interfaces';
export  enum UserStatus {
  INACTIVE,
  ACTIVE,
  LOCKED
}
export class UserConstant {
  public static readonly USER_STATUS = [
    {name: "Chưa kích hoạt", value: UserStatus.INACTIVE, badge: 'default'},
    {name: "Hoạt động", value: UserStatus.ACTIVE, badge: 'success'},
    {name: "Khóa", value: UserStatus.LOCKED, badge: 'warning'},
  ];

  private static HEADER_TABLE_BASE = [
    {
      title: 'Tên người dùng',
      field: 'name',
      // tdClassList: ['text-center'],
      tdClassList: ['font-weight-semibold'],
      width: 100,
      filterTemplate: 'filter.name',
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Tên TK',
      field: 'userName',
      filterTemplate: 'filter.userName',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 100,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Email',
      field: 'email',
      filterTemplate: 'filter.email',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 100,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Số ĐT',
      field: 'phoneNumber',
      filterTemplate: 'filter.phoneNumber',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      width: 100,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Trạng thái',
      field: 'status',
      filterTemplate: 'filter.status',
      // tdClassList: ['text-center'],
      // thClassList: ['text-center'],
      tdTemplate: 'statusTmpl',
      width: 100,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Loại tài khoản',
      field: 'userRole',
      filterTemplate: 'filter.userRole',
      tdClassList: ['text-center'],
      thClassList: ['text-center'],
      tdTemplate: 'userRoleTmpl',
      width: 100,
      sort: {
        sortDirections: ['ascend', 'descend', null],
      }
    },
    {
      title: 'Hành động',
      filterTemplate: 'filter.actionTmpl',
      tdClassList: ['text-center'],
      thClassList: ['text-center'],
      tdTemplate: 'actionTmpl',
      fixed: true,
      fixedDir: "right",
      width: 100
    },
  ];

  public static TABLE_CONFIG: AppTableConfig = {
    headers: [...UserConstant.HEADER_TABLE_BASE],
    total: 0,
    needScroll: true,
    loading: false,
    pageSize: TABLE_CONFIG_DEFAULT.pageSize,
    pageIndex: 1,
    size: 'small',
    showCheckbox: false,
    showFrontPagination: false,
    showId: true,
    bordered: true,
    showSizeChanger: true,
    showFilter: true
  };
}
